const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";

function getToken() {
    return localStorage.getItem("lumis_admin_token");
}

async function request(path, options = {}) {
    const token = getToken();
    const res = await fetch(`${API_BASE}${path}`, {
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        ...options,
    });

    const data = await res.json();

    if (res.status === 401) {
        localStorage.removeItem("lumis_admin_token");
        window.location.href = "/admin/login";
        return;
    }

    if (!res.ok) throw new Error(data.message || "Request failed");
    return data;
}

export const api = {
    // Auth
    login: (body) => request("/api/admin/auth/login", { method: "POST", body: JSON.stringify(body) }),
    getMe: () => request("/api/admin/auth/me"),

    // Stats
    getStats: () => request("/api/admin/stats"),

    // Enquiries
    getEnquiries: (params = "") => request(`/api/admin/enquiries${params}`),
    updateEnquiryStatus: (id, body) => request(`/api/admin/enquiries/${id}/status`, { method: "PATCH", body: JSON.stringify(body) }),
    deleteEnquiry: (id) => request(`/api/admin/enquiries/${id}`, { method: "DELETE" }),

    // Testimonials
    getTestimonials: () => request("/api/admin/testimonials"),
    createTestimonial: (body) => request("/api/admin/testimonials", { method: "POST", body: JSON.stringify(body) }),
    updateTestimonial: (id, body) => request(`/api/admin/testimonials/${id}`, { method: "PUT", body: JSON.stringify(body) }),
    deleteTestimonial: (id) => request(`/api/admin/testimonials/${id}`, { method: "DELETE" }),
    toggleTestimonial: (id) => request(`/api/admin/testimonials/${id}/toggle`, { method: "PATCH" }),

    // Services
    getServices: () => request("/api/admin/services"),
    createService: (body) => request("/api/admin/services", { method: "POST", body: JSON.stringify(body) }),
    updateService: (id, body) => request(`/api/admin/services/${id}`, { method: "PUT", body: JSON.stringify(body) }),
    deleteService: (id) => request(`/api/admin/services/${id}`, { method: "DELETE" }),
    toggleService: (id) => request(`/api/admin/services/${id}/toggle`, { method: "PATCH" }),
};
